import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_tag_sync_history_RowClass} from '../../../dbschema/index';


export class PriceTagSyncHistoryContainer extends BaseContainerModel {
  bl_fi_config_hdr: bl_fi_mst_price_tag_sync_history_RowClass = new bl_fi_mst_price_tag_sync_history_RowClass();
}
